import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
var shapes = new Map();
export var ShapeManager = /*#__PURE__*/function () {
  function ShapeManager(engine) {
    _classCallCheck(this, ShapeManager);
    this._engine = engine;
  }
  _createClass(ShapeManager, [{
    key: "addShape",
    value: function addShape(name, drawer) {
      if (!this.getShape(name)) {
        shapes.set(name, drawer);
      }
    }
  }, {
    key: "getShape",
    value: function getShape(name) {
      return shapes.get(name);
    }
  }, {
    key: "getSupportedShapes",
    value: function getSupportedShapes() {
      return shapes.keys();
    }
  }]);
  return ShapeManager;
}();